export const logError = (e: any) => {
  console.log(e);
};
